import { TextareaHTMLAttributes, forwardRef } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ error = false, className = '', ...props }, ref) => {
    const baseClasses = 'block w-full rounded-md shadow-sm transition-colors resize-y focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
    const borderClasses = error
      ? 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500'
      : 'border-gray-300 focus:border-blue-500';

    return (
      <textarea
        ref={ref}
        className={`${baseClasses} ${borderClasses} ${className}`}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'Textarea';
